import * as api from '../api/hsAuditExport';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_HS_AUDIT_EXPORT = createRequestTypes(
  `${prefix}/FETCH_HS_AUDIT_EXPORT`,
);

export const fetchHSAuditExport = makeApiActionCreatorV3(
  api.fetchHSAuditExport,
  FETCH_HS_AUDIT_EXPORT[START],
  FETCH_HS_AUDIT_EXPORT[SUCCESS],
  FETCH_HS_AUDIT_EXPORT[ERROR],
);

export const FETCH_HS_AUDIT_EXPORT_BY_ID = createRequestTypes(
  `${prefix}/FETCH_HS_AUDIT_EXPORT_BY_ID`,
);

export const fetchHSAuditExportByID = makeApiActionCreatorV3(
  api.fetchHSAuditExportByID,
  FETCH_HS_AUDIT_EXPORT_BY_ID[START],
  FETCH_HS_AUDIT_EXPORT_BY_ID[SUCCESS],
  FETCH_HS_AUDIT_EXPORT_BY_ID[ERROR],
);

export const INSERT_HS_AUDIT_EXPORT = createRequestTypes(
  `${prefix}/INSERT_HS_AUDIT_EXPORT`,
);

export const insertHSAuditExport = makeApiActionCreatorV3(
  api.insertHSAuditExport,
  INSERT_HS_AUDIT_EXPORT[START],
  INSERT_HS_AUDIT_EXPORT[SUCCESS],
  INSERT_HS_AUDIT_EXPORT[ERROR],
);

export const DOWNLOAD_HS_AUDIT_EXPORT_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_HS_AUDIT_EXPORT_FILE`,
);

export const downloadHSAuditExportFile = makeApiActionCreatorV3(
  api.downloadHSAuditExportFile,
  DOWNLOAD_HS_AUDIT_EXPORT_FILE[START],
  DOWNLOAD_HS_AUDIT_EXPORT_FILE[SUCCESS],
  DOWNLOAD_HS_AUDIT_EXPORT_FILE[ERROR],
);

export const FETCH_HS_AUDIT_EXPORT_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_HS_AUDIT_EXPORT_PROPERTIES`,
);

export const fetchHSAuditExportProperties = makeApiActionCreatorV3(
  api.fetchHSAuditExportProperties,
  FETCH_HS_AUDIT_EXPORT_PROPERTIES[START],
  FETCH_HS_AUDIT_EXPORT_PROPERTIES[SUCCESS],
  FETCH_HS_AUDIT_EXPORT_PROPERTIES[ERROR],
);
